module.exports = __webpack_public_path__ + "img/passenger-fill-green.9852c324.svg";